import Progress from "@visa/vds/progress";
import React from "react";
import { usePromiseTracker } from "react-promise-tracker";

export const LoadingSpinner = (props) => {
  const { promiseInProgress } = usePromiseTracker({ area: props.area });

  return (
    promiseInProgress && (
      <div style={{ display: "flex" }}>
        <Progress type="spinner" size="small" />
        <span style={{ margin: "1rem" }}>
          Security scan is being performed on the file...
        </span>
      </div>
    )
  );
};
